import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import css from "./OrdersOrdersComponent.module.css";
import { OrdersOrdersMenuComponent } from "../OrdersOrdersMenuComponent/OrdersOrdersMenuComponent";
import OrdersOrdersListComponent from "../OrdersOrdersListComponent/OrdersOrdersListComponent";
import { ModalForImportXLS } from "../../../ui";
import OrdersDaysCountModal from "../ordersSectionModals/OrdersDaysCountModal/OrdersDaysCountModal";
import { ordersActions } from "../../../store/slices/orders-slices";

const OrdersOrdersComponent = () => {
  const [isOpenImportOrdersModal, setIsOpenImportOrdersModal] = useState(false);
  const [isOpenDaysCountModal, setIsOpenDaysCountModal] = useState(false);
  const dispatch = useDispatch();

  // Clear filters when component mounts
  useEffect(() => {
    dispatch(ordersActions.clearFilters());
  }, [dispatch]);

  return (
    <section className={css.wrap}>

      <section className={css.menuBlock}>
        <OrdersOrdersMenuComponent
          setIsOpenImportOrdersModal={setIsOpenImportOrdersModal}
        />
      </section>

      <section className={css.listBlock}>
        <OrdersOrdersListComponent />
      </section>

      {isOpenDaysCountModal && (
        <OrdersDaysCountModal
          setIsOpenDaysCountModal={setIsOpenDaysCountModal}
        />
      )}

      {isOpenImportOrdersModal && (
        <ModalForImportXLS
          onClose={() => setIsOpenImportOrdersModal(false)}
          titleName={"Import orders"}
        />
      )}
    </section>
  );
};

export { OrdersOrdersComponent };
